module.exports = __webpack_public_path__ + "img/overmonterad.bec5f6da.png";